/**
 * Site-wide credit (积分) display formatter.
 *
 * Product rule (VistoeraTASK-00745): every credit amount shown in the tenant
 * UI or Platform Admin must be an integer — never trailing ".0" / ".0000".
 *
 * Display-only. Never feed the returned string back into accounting math,
 * API payloads, or ledger writes. Backend stores Numeric(18, 4); non-zero
 * fractional credits (if any) are rounded for presentation via Intl
 * `maximumFractionDigits: 0`, without mutating stored values.
 */

export function formatCredits(value: string | number | null | undefined): string {
  if (value === null || value === undefined || value === '') return '—'
  const n = typeof value === 'number' ? value : Number(value)
  if (!Number.isFinite(n)) return String(value)
  return new Intl.NumberFormat('zh-CN', { maximumFractionDigits: 0 }).format(n)
}

/** Signed ledger amount for tables that already render a ± prefix separately. */
export function formatCreditsAbsolute(value: string | number | null | undefined): string {
  if (value === null || value === undefined || value === '') return '—'
  const n = typeof value === 'number' ? value : Number(value)
  if (!Number.isFinite(n)) return String(value)
  return formatCredits(Math.abs(n))
}
